import { inject } from '@angular/core';
import { type CanActivateChildFn, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { ApiTokenService } from '../core/services/api-token.service';

/**
 * Demo-safe auth guard.
 *
 * - When `environment.demoAuth === true`, this guard never blocks navigation.
 * - When `environment.demoAuth === false`, it requires a token and redirects to `/login`.
 */
export const authGuard: CanActivateChildFn = () => {
  if (environment.demoAuth) return true;

  const tokenService = inject(ApiTokenService);
  const router = inject(Router);

  const token = tokenService.getToken();
  if (!token) return router.createUrlTree(['/login']);

  if (!tokenService.isTwoFactorConfirmed()) {
    return router.createUrlTree(['/2fa/setup']);
  }

  return true;
};
